/* eslint-disable prefer-const */
export let meta = {
    educationalData: [],
    experienceState: [],
    fullSkills: [[], []],
    ZIPCode: '',
    streetAddress: '',
  };